import React, { useState, useRef } from "react";
import "./Home.css";
import DashboardView from "../DashboardView";
import { Button, Dropdown, Menu, Modal } from "antd";
import {
  PlusOutlined,
  LeftOutlined,
  RightOutlined,
  TagOutlined,
  CloudServerOutlined,
  DashboardOutlined,
} from "@ant-design/icons";

import StatIcon1 from "../../assets/icons/stat-icon.svg";
import StatIcon2 from "../../assets/icons/stat-icon2.svg";
import StatIcon3 from "../../assets/icons/stat-icon3.svg";
import DataSourceDonut from "./Charts/DataSourceChart";
import ScheduledReportsOverview from "./ScheduledReportsOverview/ScheduledReports";
import SelectItemsTable from "./SelectItemTable/SelectItemTable";

export default function Home({ onAddGroup, onAddResource, onAddDashboard }) {
  const sliderRef = useRef(null);
  const [isAddNewModalVisible, setIsAddNewModalVisible] = useState(false);

  const dashboardStats = [
    {
      statName: "Total Groups Created",
      amount: 120,
      icon: StatIcon1,
      bgColor: "#FFF9E8",
      iconBgColor: "#CEA62514",
    },
    {
      statName: "Total Resources Added",
      amount: 120,
      icon: StatIcon2,
      bgColor: "#EBF3FF",
      iconBgColor: "#2C6BC614",
    },
    {
      statName: "Total Reports/Dashboards",
      amount: 120,
      icon: StatIcon3,
      bgColor: "#E7FAE6",
      iconBgColor: "#4D8B4914",
    },
  ];

  const dashboardCards = [
    {
      id: 1,
      title: "Dashboard1",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#6366F1",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 2,
      title: "Dashboard2",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#8B5CF6",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 3,
      title: "Dashboard3",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#06B6D4",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 4,
      title: "Dashboard4",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#10B981",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 5,
      title: "Dashboard5",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#F59E0B",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 6,
      title: "Dashboard6",
      description: "Supporting text",
      avatar: "H",
      avatarBg: "#EF4444",
      timestamp: "May 21, 2025 12:00 PM",
    },
  ];

  const dataSourceData = [
    { name: "REST API", value: 45, color: "#2a3ef9" },
    { name: "MySQL", value: 30, color: "#FF8C42" },
    { name: "GraphQL", value: 15, color: "#B8B0E6" },
    { name: "MongoDB", value: 10, color: "#1E293B" },
  ];

  const scheduledReportsData = [
    {
      id: 1,
      date: new Date(2025, 9, 1), // October 1, 2025
      time: "09:00 AM",
      title: "Weekly Sales Report",
      type: "report",
      icon: "📊",
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 2,
      date: new Date(2025, 9, 1), // October 1, 2025
      time: "11:00 AM",
      title: "Kickoff Meeting",
      type: "meeting",
      icon: "👥",
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 3,
      date: new Date(2025, 9, 3), // October 3, 2025
      time: "02:30 PM",
      title: "Client Presentation",
      type: "presentation",
      icon: "📊",
      iconBg: "#fed7aa",
      iconColor: "#ea580c",
    },
    {
      id: 4,
      date: new Date(2025, 9, 5),
      time: "10:00 AM",
      title: "Quarterly Review",
      type: "report",
      icon: "📈",
      iconBg: "#fce7f3",
      iconColor: "#db2777",
    },
    {
      id: 5,
      date: new Date(2025, 9, 7),
      time: "03:00 PM",
      title: "Product Demo",
      type: "demo",
      icon: "🎯",
      iconBg: "#e0e7ff",
      iconColor: "#6366f1",
    },
    {
      id: 6,
      date: new Date(2025, 9, 10),
      time: "11:00 AM",
      title: "Budget Planning",
      type: "meeting",
      icon: "💰",
      iconBg: "#fef3c7",
      iconColor: "#f59e0b",
    },
    {
      id: 7,
      date: new Date(2025, 9, 12),
      time: "09:30 AM",
      title: "Marketing Strategy",
      type: "presentation",
      icon: "🎨",
      iconBg: "#fecdd3",
      iconColor: "#f43f5e",
    },
    {
      id: 8,
      date: new Date(2025, 9, 12),
      time: "01:00 PM",
      title: "Performance Analysis",
      type: "report",
      icon: "📉",
      iconBg: "#d1fae5",
      iconColor: "#059669",
    },
    {
      id: 9,
      date: new Date(2025, 9, 15),
      time: "08:00 AM",
      title: "Sprint Planning",
      type: "meeting",
      icon: "⚡",
      iconBg: "#dbeafe",
      iconColor: "#2563eb",
    },
    {
      id: 10,
      date: new Date(2025, 9, 15),
      time: "11:30 AM",
      title: "Customer Feedback Review",
      type: "review",
      icon: "💬",
      iconBg: "#e0e7ff",
      iconColor: "#6366f1",
    },
  ];

  const dashboardItems = [
    {
      id: 1,
      name: "Dashboard A",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 2,
      name: "Dashboard B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 3,
      name: "Report A",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 4,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 5,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 6,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
    {
      id: 7,
      name: "Report B",
      type: "Dashboard ",
      timestamp: "May 21, 2025 12:00 PM",
    },
  ];

  const handleAddGroup = () => {
    setIsAddNewModalVisible(false);
    if (onAddGroup) onAddGroup();
  };

  const handleAddResource = () => {
    setIsAddNewModalVisible(false);
    if (onAddResource) onAddResource();
  };

  const handleAddDashboard = () => {
    setIsAddNewModalVisible(false);
    if (onAddDashboard) onAddDashboard("dashboard"); // or "reports" based on selection
  };

  const scrollLeft = () => {
    if (sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;

      // If at the beginning, jump to the end
      if (scrollLeft <= 0) {
        sliderRef.current.scrollLeft = scrollWidth - clientWidth;
      } else {
        sliderRef.current.scrollBy({ left: -280, behavior: "smooth" });
      }
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;

      // If at the end, jump to the beginning
      if (scrollLeft >= scrollWidth - clientWidth - 10) {
        sliderRef.current.scrollLeft = 0;
      } else {
        sliderRef.current.scrollBy({ left: 280, behavior: "smooth" });
      }
    }
  };

  const addNewMenu = (
    <Menu>
      <Menu.Item key="group" icon={<TagOutlined />} onClick={handleAddGroup}>
        Group
      </Menu.Item>
      <Menu.Item key="resource" icon={<CloudServerOutlined />} onClick={handleAddResource}>
        Resource
      </Menu.Item>
      <Menu.Item key="dashboard" icon={<DashboardOutlined />} onClick={handleAddDashboard}>
        Report / Dashboard
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="dashboard-container">
      <div className="dashboard-header-container">
        <h2>Home</h2>
        <div>
          <Dropdown overlay={addNewMenu} trigger={["click"]} placement="bottomRight">
            <Button type="primary" className="add-new-btn">
              Add New <PlusOutlined />
            </Button>
          </Dropdown>
        </div>
      </div>

      <div className="dashboard-stats">
        {dashboardStats.map((stat, index) => (
          <div key={index} className="stat-container" style={{ backgroundColor: stat.bgColor }}>
            <div className="stat-content">
              <div className="stat-text">
                <h3 className="stat-name">{stat.statName}</h3>
                <div className="stat-amount">{stat.amount}</div>
              </div>
              <div className="stat-icon" style={{ backgroundColor: stat.iconBgColor }}>
                <img src={stat.icon} alt="stat icon" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Most Used Dashboard Section */}
      <div className="dashboard-slider-section">
        <div className="slider-header">
          <h3 className="slider-title">Most Used Dashboard</h3>
        </div>

        <div className="slider-wrapper">
          <button className="slider-btn left" onClick={scrollLeft}>
            <LeftOutlined />
          </button>

          <div className="dashboard-cards-container" ref={sliderRef}>
            {dashboardCards.map((card) => (
              <div key={card.id} className="dashboard-card">
                <div className="card-content">
                  <div className="card-info">
                    <h4 className="card-title">{card.title}</h4>
                    <p className="card-description">{card.timestamp}</p>
                  </div>
                  {/* <div className="card-avatar" style={{ backgroundColor: card.avatarBg }}>
                    <span>{card.avatar}</span>
                  </div> */}
                </div>
                <div className="card-icon">
                  <img src={StatIcon2} alt="" />
                </div>
              </div>
            ))}
          </div>

          <button className="slider-btn right" onClick={scrollRight}>
            <RightOutlined />
          </button>
        </div>
      </div>

      {/* Chart Section */}
      <div className="dashboard-chart-section">
        <div className="data-source-usage">
          <h3
            style={{
              margin: "-1rem 0 3rem 1rem ",
              fontSize: "1.25rem",
              fontWeight: 600,
              color: "#1a1a1a",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Data Source Usage
          </h3>
          <DataSourceDonut dataSourceData={dataSourceData} />
        </div>

        <div className="data-overview-usage">
          {/* Select itemsSection */}
          <SelectItemsTable items={dashboardItems} />
        </div>
      </div>

      <div className="data-overview-usage">
        <ScheduledReportsOverview scheduledReportsData={scheduledReportsData} />
      </div>
    </div>
  );
}
